/**
 * Company: SPHMedia
 * Description: [MyBH page heading with menu]
 */

import MyBHLogo from "@assets/images/mybh-logo.svg";
import TileBg from "@assets/images/tile-mybh.svg";
import MySphLoginButton from "@components/Modules/HeaderNew/MySphLoginButton";
import UserInfo from "@components/Modules/HeaderNew/UserInfo/UserInfo";
import { User } from "@hooks/useMySPHLightbox";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import WidgetWrapper from "../../Home/HomePageLayout/WidgetWrapper";
import MyBHMenu from "./MyBHMenu";

type MyBHPageHeadingProps = {
  visitorId: string;
  userInfo: User;
  activeTab: "untukmu" | "pilihanku";
  onTabChange: (tab: "untukmu" | "pilihanku") => void;
  hideMenu?: boolean;
};

/**
 * MyBHPageHeading
 * Description: [MyBH page heading logo + breadcrumb + menu]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHPageHeading({
  visitorId,
  userInfo,
  activeTab,
  onTabChange,
  hideMenu,
}: MyBHPageHeadingProps): ReactElement {
  return (
    <>
      <div
        id="mybh-header"
        style={{
          backgroundImage: `url(${TileBg}),
            linear-gradient(180deg, #C4E5FF 0%, rgba(196,229,255,0) 100%)`,
          backgroundRepeat: "repeat-x, no-repeat",
          backgroundPosition: "top, top",
          backgroundSize: "auto 19px, 100% 100%",
        }}
        className="relative -mt-3 lg:-mt-md pb-8 md:pb-6 pt-5 border border-brand-primary border-x-0 border-b-0 border-t-2"
      >
        <WidgetWrapper className="px-0">
          <div className="flex flex-col justify-center items-center pt-3">
            <div className="md:hidden px-4 self-start flex justify-between w-full">
              <div className="flex gap-2 items-center text-text-body font-bold">
                <span
                  style={{
                    fontFamily: "Noto Sans Symbols",
                  }}
                  className="text-sm leading-[100%]"
                >
                  {"⌂  >"}
                </span>
                <span className="font-primary text-[11px] leading-[120%]">
                  BHku
                </span>
              </div>
              <div>
                {visitorId ? (
                  <div className="relative">
                    <UserInfo
                      rootClassName="flex items-center"
                      userInfo={userInfo}
                      variant="mybh"
                    />
                  </div>
                ) : (
                  <MySphLoginButton
                    buttonStyle="text-[14px] text-brand-primary"
                    textStyle="font-medium"
                    iconWidth="12px"
                    iconHeight="12px"
                  />
                )}
              </div>
            </div>
            <div className="pt-2.5">
              <img src={MyBHLogo} width={80} height={24} alt="mybh-logo" />
            </div>
          </div>
          <div
            className={twMerge(
              "transition-opacity duration-200",
              hideMenu ? "opacity-0 pointer-events-none" : "opacity-100",
            )}
          >
            <MyBHMenu activeTab={activeTab} onTabChange={onTabChange} />
          </div>
        </WidgetWrapper>
      </div>
    </>
  );
}
